<div class="space-y-4">
    <div *ngIf="loading" class="flex justify-center items-center py-8">
        <div class="text-gray-500">Carregando anexos...</div>
    </div>

    <div *ngIf="!loading" class="flex items-center justify-center mb-4 gap-2 w-full">
        <div class="flex items-center justify-center gap-3">
            <button mat-stroked-button color="primary" (click)="fileInput.click()" class="h-14 flex items-center">
                <mat-icon [svgIcon]="'heroicons_outline:arrow-up-tray'"></mat-icon>
                {{
                    singleFile && (attachments.length || pendingAttachments.length)
                        ? 'Trocar Arquivo'
                        : 'Selecionar Arquivo'
                }}
            </button>
            <input
                #fileInput
                type="file"
                [multiple]="!singleFile"
                class="hidden"
                (change)="onSelectFiles($event)"
            />
            <button
                *ngIf="hasChanges && !deferSave"
                mat-flat-button
                color="primary"
                (click)="saveAttachments()"
                [disabled]="loading"
                class="h-14 flex items-center"
            >
                <mat-icon [svgIcon]="'heroicons_outline:check'"></mat-icon>
                Salvar Anexos
            </button>
        </div>
    </div>

    <div *ngIf="!loading && attachments.length === 0 && pendingAttachments.length === 0" class="text-center py-8">
        <mat-icon class="text-gray-400 text-5xl mb-2" svgIcon="heroicons_outline:paper-clip"></mat-icon>
        <p class="text-sm text-gray-500 dark:text-gray-400">
            {{ singleFile ? 'Nenhum arquivo anexado' : 'Nenhum anexo' }}
        </p>
    </div>

    <div *ngIf="!loading && pendingAttachments.length > 0" class="space-y-2 mb-4">
        <div class="text-sm font-semibold text-gray-600 dark:text-gray-400">
            {{ singleFile ? 'Arquivo pendente' : 'Pendentes de Envio' }}
        </div>
        <div
            *ngFor="let item of pendingAttachments; let i = index"
            class="flex items-center justify-between p-3 rounded border border-dashed border-gray-300 bg-gray-50 dark:bg-transparent dark:border-gray-600"
        >
            <div class="flex items-center gap-3 min-w-0">
                <mat-icon [svgIcon]="'heroicons_outline:clock'" class="text-amber-600"></mat-icon>
                <div class="min-w-0">
                    <div class="font-medium truncate">{{ item.file.name }}</div>
                    <div class="text-xs text-amber-700">Não enviado</div>
                </div>
            </div>
            <button mat-icon-button color="warn" (click)="removePending(i)" [matTooltip]="'Remover'">
                <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
            </button>
        </div>
    </div>

    <div *ngIf="!loading && attachments.length > 0" class="space-y-1">
        <div
            *ngFor="let file of attachments"
            class="flex items-center justify-between p-3 rounded border border-gray-200 dark:border-gray-700 bg-white dark:bg-transparent"
            [class.cursor-pointer]="isImage(file) || isPdf(file)"
            (click)="onFileClick(file, $event)"
        >
            <div class="flex items-center gap-3 min-w-0 flex-1">
                <mat-icon [svgIcon]="getFileIcon(file)" class="text-gray-500"></mat-icon>
                <div class="min-w-0 flex-1">
                    <div class="font-medium truncate">{{ getDisplayName(file) }}</div>
                    <div class="text-xs text-gray-500 truncate">{{ file.createdAt | date : 'dd/MM/yy HH:mm' }}</div>
                </div>
            </div>
            <div class="flex items-center gap-1" (click)="$event.stopPropagation()">
                <button mat-icon-button (click)="download(file)" title="Baixar">
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
                </button>
                <button mat-icon-button color="warn" (click)="remove(file)" title="Remover">
                    <mat-icon [svgIcon]="'heroicons_outline:trash'"></mat-icon>
                </button>
            </div>
        </div>
    </div>
</div>
